import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Home: React.FC = () => {
    return (
        <div className="container mt-5">
            <div className="jumbotron">
                <h1 className="display-4">Welcome to the Trading App</h1>
                <p className="lead">Your gateway to the world of financial trading.</p>
                <hr className="my-4" />
                <p>
                    Explore real-time market data, analyze trends, and execute trades with ease. Whether you're a seasoned investor or just starting, our platform provides the tools you need to succeed.
                </p>
                <a className="btn btn-primary btn-lg" href="#" role="button">
                    Learn more
                </a>
            </div>

            <div className="row">
                <div className="col-md-4">
                    <h2>Market Analysis</h2>
                    <p>Stay informed with our comprehensive market analysis tools.</p>
                </div>
                <div className="col-md-4">
                    <h2>Real-Time Data</h2>
                    <p>Access up-to-the-minute data for informed decision-making.</p>
                </div>
                <div className="col-md-4">
                    <h2>Secure Trading</h2>
                    <p>Trade with confidence on our secure and reliable platform.</p>
                </div>
            </div>
        </div>
    );
};

export default Home;